var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2946 22.2077L19.4839 18.3239C20.6294 17.2599 21.4345 15.8738 21.7959 14.3435C22.1573 12.8132 22.0585 11.2086 21.5122 9.73548L19.7257 4.90844C19.0583 3.10636 17.7369 1.62955 16.0309 0.778893C14.3248 -0.0717688 12.3625 -0.232286 10.5435 0.330043C3.84995 2.40216 -1.29505 8.69745 0.288628 16.1729C1.33011 21.0907 3.32336 27.2636 7.09922 33.8313C10.8829 40.4147 15.2048 45.2772 18.9105 48.6952C24.5041 53.8459 32.5005 52.5592 37.6455 47.7046C39.0238 46.4029 39.86 44.6187 39.984 42.7151C40.1079 40.8116 39.5102 38.9318 38.3125 37.4584L35.0359 33.4326C34.0477 32.2152 32.7221 31.3248 31.2296 30.8761C29.7371 30.4273 28.146 30.4407 26.6611 30.9145L21.247 32.6393C19.848 31.18 18.6226 29.5599 17.596 27.8122C16.6052 26.0449 15.8323 24.1613 15.2946 22.2037",
    fill: "#FE8839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.22a38284ddd6f1b7b522baf0e4634158.svg";
export { ForwardRef as ReactComponent };